export default "__VITE_ASSET__Cr3iArx3__"